function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.14713 14.0331L1.08647 12.9724L2.14713 14.0331L14.0331 2.14714C14.4474 1.73278 15.0094 1.5 15.5954 1.5L32.4046 1.5C32.9906 1.5 33.5526 1.73278 33.9669 2.14713L45.8529 14.0331C46.2672 14.4474 46.5 15.0094 46.5 15.5954L46.5 32.4046C46.5 32.9906 46.2672 33.5526 45.8529 33.9669L33.9669 45.8529C33.5526 46.2672 32.9906 46.5 32.4046 46.5H15.5954C15.0094 46.5 14.4474 46.2672 14.0331 45.8529L12.9724 46.9135L14.0331 45.8529L2.14714 33.9669C1.73278 33.5526 1.5 32.9906 1.5 32.4046L1.5 15.5954C1.5 15.0094 1.73278 14.4474 2.14713 14.0331Z",
  stroke: "#FF6534",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 15L24.5 27.5",
  stroke: "#FF6534",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 33.5,
  r: 1.5,
  fill: "#FF6534"
});

const SvgRedExclamationSign = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedExclamationSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/red_exclamation_sign.bac74914.svg";
export { ForwardRef as ReactComponent };